import { Component } from 'react';
import { reportClientError } from '@/lib/errorReporter';

export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportClientError(error?.message || 'React render error', `${error?.stack || ''}\n${info?.componentStack || ''}`, 'react');
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5] px-4" data-testid="error-boundary-fallback">
          <div className="text-center max-w-md">
            <h1 className="text-2xl font-bold text-[#0D3B4F] mb-2">Something went wrong</h1>
            <p className="text-[#4E6974] mb-6">The error has been logged and our team will look into it. Try reloading, or head back home.</p>
            <button
              onClick={() => window.location.assign('/')}
              className="px-5 py-2.5 bg-[#00707C] text-white rounded-lg text-sm font-medium hover:bg-[#00707C]/90"
              data-testid="error-boundary-home-btn"
            >
              Back to home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
